import { gql } from 'apollo-angular'

export const REQUEST_SEAT = gql`
  mutation RequestSeat($magazineId: Int!) {
    requestSeat(data: { magazineId: $magazineId }) {
      success
    }
  }
`
